// How to create more files like this:
// ===================================
//
// where does it live
// how to populate from server
// adding a new package
//
// - remove comments because they are not needed from the old version
// - comment rest of the code which is useful (it will be toggled later)
// - get minimal version working ("hello world")
//
// it is simliar to o

import React from "react";
import {connect} from "react-redux";
import {compose, lifecycle} from "recompose";
import Button from "react-md/lib/Buttons/Button";
import {TouchTable} from "../../../AtollonTheme/ReactElements";

import {
    getPerson,
    getOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser,
    getHostCategories
} from "../../../actions/resourceActions";
import {
    addHostCategories
} from "../../../actions/HostCategoriesActions";
import {} from "../../../actions/requestActions";
import {DebugElement} from "../../debug";
import {map, isEmpty, find, forEach} from "lodash";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import { setDialog } from "../../../actions/dialogActions";
import {
    isAdmin
} from "../../../utils/index"


import {HostCategoriesHeaderAsRedux} from "./HostCategoriesHeader";
import {HostCategories_Add_and_Edit_AsRedux} from "./HostCategories_Add_and_Edit";


// borrowed from current ui
import Header from "../../../components/ContainerHeader";

import {InfoBox, InfoBox_Field, InfoBox_TextField} from "../../../AtollonTheme/ReactElements";
import {
    ADD_HOST_CATEGORIES_FORM_NAME,
    hostCategories_getRoutePathStringForForNavigationContainer,
    hostCategories_getDetailIdFromPath
} from "./shared";

const HostCategoriesAsReact = ( propsAsDict ) => {

    let {
        location,
        history,
        state
    } = propsAsDict;

    if( state.form && state.resource )
    {
            let {
                app: {
                    role,
                    form: {
                        activeForm
                    }
                },
                resource: {
                    //              person,
                    hostCategories,
                    //              organizationUsers,
                    //              organizationUsersAdmin,
                    //              organizationUsersOwner,
                    //              organizationUsersUser
                }
            } = state;

            console.log( {hostCategories, state} );

            let admin = isAdmin(role);
            if( admin )
            {
                    let headerAsList = ["id","Název"];
                        headerAsList.push("Akce");

                    let HostCategories_id = hostCategories_getDetailIdFromPath( location );

                    // console.log('RRR','HostCategories', {location});
                    // console.log('RRR','HostCategories', {HostCategories, propsAsDict});

                    let isAdding = activeForm === ADD_HOST_CATEGORIES_FORM_NAME;
                    let isEditing = HostCategories_id;

                    // console.log('RRR','HostCategories', {isAdding, isEditing});
                    // console.log('RRR','HostCategories', {HostCategories_id});
                    let top;
                    if( isEditing )
                    {
                        let initialValuesOfEditedId = {};
                        forEach( hostCategories, (item) => {
                            if( item.id === HostCategories_id )
                            {
                                initialValuesOfEditedId = item;
                            }
                        });
                        top = (
                            <div>
                                <HostCategoriesHeaderAsRedux
                                    HostCategories_id={HostCategories_id}
                                />
                                <HostCategories_Add_and_Edit_AsRedux
                                    HostCategories_id={HostCategories_id}
                                    history={history}
                                    initialValues={initialValuesOfEditedId}
                                />
                            </div>
                        );
                    }
                    else if( isAdding )
                    {
                        top = (
                            <div>
                                <HostCategoriesHeaderAsRedux
                                    HostCategories_id={HostCategories_id}
                                />
                                <HostCategories_Add_and_Edit_AsRedux
                                    history={history}
                                    initialValues={{}}
                                />
                            </div>
                        );
                    }
                    else
                    {
                        top = ( <HostCategoriesHeaderAsRedux /> );
                    }

                    return (
                        <div>

                            {top}

                            {isEditing || isAdding?
                                (<div/>)
                                :
                                <TouchTable
                                    headerAsList={headerAsList}
                                    elementsAsList={map(hostCategories, (item, i) => {


                                            let id_actionName = item.id;
                                            let name_asctionName = item.name;
                                            let fields = [
                                                id_actionName,
                                                name_asctionName
                                            ];

                                            if( admin )
                                            {
                                                fields.push((
                                                    <div className="table-col actions">

                                                        <Button
                                                            raised
                                                            className="btn btn-primary"
                                                            onClick={(event) => {

                                                                // do not
                                                                event.preventDefault();

                                                                history.push(hostCategories_getRoutePathStringForForNavigationContainer( item.id ));

                                                            }}>Editovat</Button>
                                                    </div>
                                                ));
                                            }
                                            return fields;
                                        }
                                    )}
                                />
                            }
                        </div>
                    );
            }
            else
            {
                return null;
            }
    }
    else
    {
        return null;
    }
};

/**
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 */

export const HostCategoriesAsRedux = compose(
    connect(
        (state) => {


            return (
                {
                    // role,
                    // // person
                    // HostCategories,
                    state,
                    // activeForm
                });
        },
        {
            // getPerson,
            // getOrganizationUserDetail,
            // getOrganizationUsers,
            // getOrganizationUsersAdmin,
            // getOrganizationUsersOwner,
            // getOrganizationUsersUser,
            // setDialog
            isAdmin,
            getHostCategories
        }
    ),
    lifecycle(
        {
            async componentWillMount() {
                const {getHostCategories} = this.props;
                await getHostCategories();
            }
        }
    )
)(HostCategoriesAsReact);




// WEBPACK FOOTER //
// ./src/Atollon/pages/HostCategories/HostCategories.js